import { render, staticRenderFns } from "./MerchantProduct.vue?vue&type=template&id=216f8c55&scoped=true&"
import script from "./MerchantProduct.vue?vue&type=script&lang=js&"
export * from "./MerchantProduct.vue?vue&type=script&lang=js&"
import style0 from "./MerchantProduct.vue?vue&type=style&index=0&id=216f8c55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216f8c55",
  null
  
)

component.options.__file = "MerchantProduct.vue"
export default component.exports